import {
  ApartmentOutlined,
  FormOutlined,
  SlidersOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import messageIds from "src/locales/messageIds";
import { UserAuthoritiyEnum } from "src/models/license";

export interface MenuItems {
  subKey?: string;
  key?: string;
  name: string;
  userAuthoritiy: UserAuthoritiyEnum;
  iconType: any;
  type?: string;
  path?: string;
  search?: string;
  children?: Array<{ key: string; name: string; path: string; search: string }>;
}

export const menus: MenuItems[] = [
  {
    key: "user",
    name: messageIds.menu.userManagement.name,
    userAuthoritiy: UserAuthoritiyEnum["CompanyManage"],
    iconType: UserOutlined,
    path: "/userManage",
    search: "",
  },
  {
    subKey: "companyManage",
    name: messageIds.menu.company.name,
    userAuthoritiy: UserAuthoritiyEnum["CompanyManage"],
    iconType: ApartmentOutlined,
    type: "companyManage",
    children: [
      {
        key: "communityTenant",
        name: messageIds.menu.company.community.name,
        path: "/companyManage/communityTenant",
        search: "",
      },
      {
        key: "enterpriseTenant",
        name: messageIds.menu.company.enterprise.name,
        path: "/companyManage/enterpriseTenant",
        search: "",
      },
    ],
  },
  {
    subKey: "license",
    name: messageIds.menu.license.name,
    userAuthoritiy: UserAuthoritiyEnum["LicenseManage"],
    iconType: FormOutlined,
    type: "license",
    children: [
      {
        key: "licenseManage",
        name: messageIds.menu.license.list.name,
        path: "/license/licenseManage",
        search: "",
      },
      {
        key: "console",
        name: messageIds.menu.license.console.name,
        path: "/license",
        search: "console",
      },
      {
        key: "premiumRobot",
        name: messageIds.menu.license.premiumRobot.name,
        path: "/license",
        search: "premiumRobot",
      },
      {
        key: "studio",
        name: messageIds.menu.license.studio.name,
        path: "/license",
        search: "studio",
      },
      {
        key: "localOCR",
        name: messageIds.menu.license.localOCR.name,
        path: "/license",
        search: "localOCR",
      },
    ],
  },
  {
    key: "installation",
    name: messageIds.menu.installation.name,
    userAuthoritiy: UserAuthoritiyEnum["CompanyManage"],
    iconType: UploadOutlined,
    path: "/installation",
    search: "",
  },
  {
    subKey: "ai",
    name: messageIds.menu.aiManagement.name,
    userAuthoritiy: UserAuthoritiyEnum["CompanyManage"],
    iconType: SlidersOutlined,
    type: "ai",
    children: [
      {
        key: "serviceManage",
        name: messageIds.menu.aiManagement.service.name,
        path: "/ai/serviceManage",
        search: "",
      },
      {
        key: "userServiceManage",
        name: messageIds.menu.aiManagement.userService.name,
        path: "/ai/userServiceManage",
        search: "",
      },
      {
        key: "userManage",
        name: messageIds.menu.aiManagement.user.name,
        path: "/ai/userManage",
        search: "",
      },
    ],
  },
];
